// firebase.ts
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getFunctions } from "firebase/functions"
import { getAnalytics } from "firebase/analytics"
import { firebaseConfig } from "./envs"
declare global {
  interface Window {
    FIREBASE_APPCHECK_DEBUG_TOKEN: boolean
  }
}

const app = initializeApp(firebaseConfig)
let appCheck = null
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app, "us-central1")

// const isLocalhost = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)

// if (isLocalhost) {
//   window.FIREBASE_APPCHECK_DEBUG_TOKEN = true

//   appCheck = initializeAppCheck(app, {
//     provider: new ReCaptchaV3Provider(REACT_APP_RECAPTCHA_SITE_KEY || ""),
//     isTokenAutoRefreshEnabled: false
//   })
//   connectFirestoreEmulator(db, "127.0.0.1", 8080)
//   connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: false })
//   connectFunctionsEmulator(functions, "127.0.0.1", 5001)
// } else {
//   // Production / non-local: real App Check
//   appCheck = initializeAppCheck(app, {
//     provider: new ReCaptchaV3Provider(REACT_APP_RECAPTCHA_SITE_KEY || ""),
//     isTokenAutoRefreshEnabled: true
//   })
// }
// ✅ Only initialize Analytics in browser and when ID exists
// let analytics: ReturnType<typeof getAnalytics> | undefined
// if (typeof window !== "undefined" && REACT_APP_measurementId) {
//   analytics = getAnalytics(app)
// }
const analytics = getAnalytics(app)

export { auth, db, analytics, appCheck, functions }
